<script setup>

import { BModal, BButton, BTabs, BTab, BRow, BCol, BFormInput, BFormSelect, BFormTextarea, BTable, BTr,BTh, BBadge} from 'bootstrap-vue-next';
import HeaderContent from '@/components/HeaderContent.vue';
import ActionContent from '@/components/ActionContent.vue';
import ButtonCta from '@/components/ButtonCta.vue';
// import StatisticData from '@/components/StatisticData.vue';
import DataTable from '@/components/DataTable.vue';
import InventoryModalForm from '../InventoryModalForm.vue';
// import iconProduct from '../../../../public/icons/box-open.svg';
// import iconItem from '../../../../public/icons/boxes.svg';
// import iconSpoil from '../../../../public/icons/damage.svg';
// import iconOverall from '../../../../public/icons/square-poll-vertical.svg';
import {  reactive, watch, ref, inject, onMounted, } from 'vue';





const repositories = inject('repositories');

const inventoryRoomRepository = repositories ? repositories.inventoryRoom : null;
const inventoryData = ref([])
const inventoryTableFields = ref([
  {key : 'name', label : 'Name',},
  {key : 'category', label : 'Category',},
])

const inventoryHeaderRoomType = ref([])

const dataHistory = reactive({
  togle : false,
  data : [],
})

const dataDistribution = reactive({
  togle : false,
  loading : false,
  id: '',
  itemName : '',
  current : "Last qty",
  new : "New qty",
  data : [],
  update : [],
  input : reactive({}),
  // 

})
// const itemDistribution = ref([])


const selectOption = reactive({
  roomType : 'Select Type',
  roomNumber : 'Select Room',
  item : 'Select Item',
  moveTo : 'Move to',
})

const inventoryModal = ref(false)

watch(()=>selectOption.roomNumber, () => {
  
  dataDistribution.current = `Last Qty : ${dataDistribution.data[selectOption.roomNumber]}`

})


// watch(()=>dataDistribution.togle, (newVal) => {
  
//   newVal === true ? getAllDistribution(dataDistribution.id) : [{asd : 'asd'}]

// })

const togleHistory = (theData) => {
  dataHistory.data = []
  dataHistory.togle = !dataHistory.togle
  dataHistory.data = historyitem.map(i => i.id == theData.id ? i : null).filter(i => i != null)

}

// const togleDistribution = (data) => {
//   dataDistribution.id = data.id
  
//   // dataDistribution.data = itemDis.data
//   // alert(JSON.stringify(dataDistribution.data))
//   // dataDistribution.data.push(data)
//   dataDistribution.input = data
//   selectOption.item = data
//   const tes = Object.entries(dataDistribution.input)
  
  
// }



const customActions = ref([
  {
      label: 'History',
      variant: 'primary',
      icon: 'fas fa-history',
      action: (item) => {
        togleHistory(item)
      // Implement your Info logic here
      }
  },
  {
      label: 'Distribution',
      variant: 'warning',
      icon: 'fas fa-layer-group',
      action: (item) => {
      getAllDistribution(item.id)

      // Implement your Payment logic here
      }
  },
  
])
// itemdis



const getAll = async () => {
    await inventoryRoomRepository.getAll().then((res) => {
      const inventoryResponse = res.data.data 
      // table field
       // Pertama proses semua data
      inventoryResponse[0].room.forEach((item) => {
        item.room_data.forEach((y) => {
          inventoryTableFields.value.push({
            key: y.room_code,
            label: y.room_code,
            class: 'text-center'
          });
        });
      });

      // add action in the last interation
      inventoryTableFields.value.push({
        key: 'action',
        label: 'Actions',
        class: 'text-center'
      });

      // table room type section
      inventoryResponse[0].room.map((item) => 
        inventoryHeaderRoomType.value.push({key : item.room_type, label : item.room_type, count : item.room_data.length, color : item.room_color})    
      )
      // table room data
        inventoryResponse.map((item, index) => {
          inventoryData.value[index] = { 
            id: item.uuid,
            name: item.item_name, 
            category: item.type 
          };

          item.room.forEach(y => {
            y.room_data.forEach(x => {
              inventoryData.value[index] = { 
                ...inventoryData.value[index], 
                [x.room_code]: parseInt(x.total) 
              };
            });
          });

          return inventoryData.value[index];
        });
    console.log(inventoryData.value)
       
    console.log(inventoryTableFields.value)
    }).catch(err => {
    console.error(err)
    })
};

const getAllDistribution = async (itemId) => {
  dataDistribution.loading = true
  dataDistribution.togle = !dataDistribution.togle
  try{
    const getData = await inventoryRoomRepository.getAllDistribution({id:itemId})
    dataDistribution.data = getData.data
    dataDistribution.itemName = getData.data.item_name
    dataDistribution.id = getData.data.id
    console.log('get data rty',dataDistribution.data)
  }catch(e){
    console.log(e)
  }finally{
    dataDistribution.loading = false
  }
}

const updateDistribution = async () =>{
  const uuid = dataDistribution.id
  const y = {data:[]}
  dataDistribution.data.data.map((item) => {
    item.room.map(z=>{
      y.data.push({stock_uuid : z.stock_uuid, total : z.total})
    })
  })

  // const x = dataDistribution.data.data.map((item) => {
  //   y.data.push(item)
  // })
  try{
    inventoryRoomRepository.updateDistribution('uuid', y)
  }catch(e){
    console.log(e)
  }
  
  console.log('tes update distribution',JSON.stringify(y))
}

onMounted(() => {
    getAll();
});

</script>

<template>
  <HeaderContent title="Room Inventory"/>
  <ActionContent :filterDate="false" :cta="false"></ActionContent>

    <!-- Table -->
    <div class="mt-4 table-responsive bg-white rounded-3 mb-0">
        <div class="p-4">
            <div class="d-lg-flex">
                <ButtonCta class="" v-if=" inventoryName !== 'spoil' && inventoryName !== 'overall' " text="Add New" show="true" @action="inventoryModal = !inventoryModal"></ButtonCta>
            </div>
        </div>
        <DataTable :data="inventoryData" class="text-center" :header="inventoryTableFields" :custom-actions="customActions">
          <template #thead-top>
            <BTr>
            <BTh colspan="2" ><span class="visually-hidden">ID, Name, Category </span></BTh>
            <BTh v-for="(item,index) in inventoryHeaderRoomType" :key="index" :class="item.count == 0 ? 'd-none' : ''" :colspan="item.count" :style="{'background-color': item.color}">{{ item.label}}</BTh> 
            </BTr>
          </template>
        </DataTable>

    </div>
   
    <!-- Modal History -->
    <BModal id="modal-tall" size="xl" v-model="dataHistory.togle" no-footer centered  title="History"> 
      <template #header>
        <div class="d-flex align-items-center justify-content-between modal-title w-100">
          <h5 class="">History</h5>
        </div>
        <BButton
          variant="link"
          class="close"
          @click="dataHistory.togle = false"
        >
          <i class="ion ion-android-close"></i>
        </BButton>
      </template>
      
      <DataTable v-if="dataHistory.data.length > 0" :data="dataHistory.data" :header="historyHeader"></DataTable>
      <div v-if="dataHistory.data.length == 0" class="p-4">
        <span class="text-secondary">No data</span>
      </div>
        
    </BModal>

    <BModal id="modal-tall" v-model="dataDistribution.togle" :title="dataDistribution.itemName" @update:modelValue="updateModal" size="lg"> 
       

      <!-- Modalform -->
    <InventoryModalForm v-model="inventoryModal" @update:modal="modal = $event"></InventoryModalForm>
       <!-- Tabs  -->

       <InventoryModalForm v-model="inventoryModal" @update:modal="modal = $event"></InventoryModalForm>
       <!-- Tabs  -->
       <BTabs content-class="mt-3"  >
        <!-- Tab Distribution -->
         <BTab v-if="dataDistribution.loading === false" BTab title="Distribute" active >
           <BRow >
            <BCol v-for="(item,index) in dataDistribution.data.data" :key="index" >
              
              <div
              class="w-100"
                :style="{'background-color': item.type_color}"
              >
              <h6>
                {{ item.type_name }}
              </h6></div>
              <BBadge></BBadge>

              
              <div v-for="(item_room,room_index) in item.room" :key="room_index">
                <BTable stacked :items="[{[item_room.room_number] : 2}]" >
               
                <template #cell()>
                  <div class="text-center ">
                    <BFormInput type="number" v-model="dataDistribution.data.data[index].room[room_index].total"  ></BFormInput>
                    <!-- <BFormInput type="number" v-model="s"  ></BFormInput> -->
                  </div>
                </template>
              </BTable>
              </div>
              <BTable></BTable>
           </BCol>
          </BRow>
                     
         </BTab>

         <!-- Tab spoil -->
           <BTab title="Spoil">
             <BRow>
               <BCol>
                 <BFormSelect :options="option.room_type" v-model="selectOption.roomType"></BFormSelect>
               </BCol>
               <BCol>
                 <BFormSelect :options="option.room_number" v-model="selectOption.roomNumber"></BFormSelect>
               </BCol>
             </BRow>
     
             <BRow class="mt-3">
               <BCol>
                 <BFormInput type="number"  v-model="dataDistribution.current" placeholder="Total Spoil "></BFormInput>
                 
               </BCol>
             </BRow>
         
             <BFormTextarea class="mt-3" placeholder="Remark"></BFormTextArea>
           </BTab>
         </BTabs>
         <template #footer>
          <div class="d-flex justify-content-end">
              <BButton variant="primary" @click="updateDistribution" class="mr-2">Save</BButton>
              <BButton variant="danger" @click="dataDistribution.togle = false">Cancel</BButton>
          </div>
      </template>
         
   </BModal>
</template>




<script>



const historyitem = [
{
    id: 'I002',
    name: 'Single Sheet',
    category : 'item',
    qty : 1,
    desc : "Move item to Room A02",
    remark : '-',
    updated_at : '2022-01-01',
    updated_by : 'Mr Admin',
  },
  {
    id: 'I001',
    name: 'Double Sheet',
    category : 'item',
    qty : 2,
    desc : "Added item to room A02",
    remark : '-',
    updated_at : '2022-01-01',
    updated_by : 'Mr Admin',
  },
  {
    id: 'I001',
    name: 'Double Sheet',
    category : 'item',
    qty : 1,
    desc : "Move item to Spoil",
    remark : 'Rusak karena puntung rokok',
    updated_at : '2022-01-01',
    updated_by : 'Mr Admin',
  },
  {
    id: 'I002',
    name: 'Single Sheet',
    category : 'item',
    qty : 1,
    desc : "Move item to Room A02",
    remark : '-',
    updated_at : '2022-01-01',
    updated_by : 'Mr Admin',
  },
  {
    id: 'I003',
    name: 'Single Sheet',
    category : 'item',
    qty : 1,
    desc : "Move item to Room A02",
    remark : '-',
    updated_at : '2022-01-01',
    updated_by : 'Mr Admin',
  },
]


const option = {
    room_type:[
      {
        value : 'Select Type',
        text : 'Select Type'
      },
      {
        value : 'Deluxe',
        text : 'Deluxe'
      },
      {
        value : 'Super Deluxe',
        text : 'Super Deluxe'
      },
      {
        value : 'Suite',
        text : 'Suite'
      },
      {
        value : 'Family',
        text : 'Family'
      },
      
    ],
    room_number : [
      {
        value : 'Select Room',
        text : 'Select Room'
      },
      {
        value : 'A03',
        text : 'A03'
      },
      
      {
        value : 'A04',      
        text : 'A04'
      },
      {
        value : 'B01',      
        text : 'B01'
      },
      {
        value : 'B03',      
        text : 'B03'
      },
      {
        value : 'C01',      
        text : 'C01'
      },
      {
        value : 'C03',      
        text : 'C03'
      },
    ],
    item : [
      {
        value : 'Select Item',
        text : 'Select Item'
      },
      {
        value : 'Double Sheet',
        text : 'Double Sheet'
      },
      {
        value : 'Single Sheet',      
        text : 'Single Sheet'
      },
      {
        value : 'Bath Towel',      
        text : 'Bath Towel'
      },
    ],
    // moveTo : [
    //   {
    //     value : 'Move to',
    //     text : 'Move to'
    //   },
    //   {
    //     value : 'Warehouse',
    //     text : 'Warehouse'
    //   },
    //   {
    //     value : 'Spoil',      
    //     text : 'Spoil'
    //   }
    // ]
    
}

</script>